/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgBankingControllerGetBankingParamsGen,
  ThgBankingControllerNewBankingParamsGen,
  ThgBankingDtoGen,
  ThgBankingViewModelGen,
  ThgExceptionViewmodelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Banking<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerGetMyBankingInformation
   * @summary Get my Banking informations
   * @request GET:/banking/me
   * @secure
   * @response `200` `ThgBankingViewModelGen` The Bankinginformations of a user
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  bankingControllerGetMyBankingInformation = (params: RequestParams = {}) =>
    this.http.request<ThgBankingViewModelGen, ThgExceptionViewmodelGen>({
      path: `/banking/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerCreateOrUpdateBankingMe
   * @summary Creates or Update my Bankinginformations
   * @request POST:/banking/me
   * @secure
   * @response `200` `ThgBankingViewModelGen` The record has been successfully created
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  bankingControllerCreateOrUpdateBankingMe = (data: ThgBankingDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgBankingViewModelGen, ThgExceptionViewmodelGen>({
      path: `/banking/me`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerNewBanking
   * @summary Creates BankingInformation as admin
   * @request POST:/banking
   * @secure
   * @response `201` `ThgBankingViewModelGen` The record has been successfully created
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  bankingControllerNewBanking = (
    query: ThgBankingControllerNewBankingParamsGen,
    data: ThgBankingDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgBankingViewModelGen, ThgExceptionViewmodelGen>({
      path: `/banking`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerGetBanking
   * @summary Gets Banking Informations as admin
   * @request GET:/banking
   * @secure
   * @response `200` `ThgBankingViewModelGen` The found Record
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  bankingControllerGetBanking = (query: ThgBankingControllerGetBankingParamsGen, params: RequestParams = {}) =>
    this.http.request<ThgBankingViewModelGen, ThgExceptionViewmodelGen>({
      path: `/banking`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerCreateOrUpdateBankingForPartner
   * @summary Create or update BankingInformation as Partner
   * @request POST:/partner/{partnerId}/banking
   * @secure
   * @response `201` `ThgBankingViewModelGen` The record has been successfully created
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  bankingControllerCreateOrUpdateBankingForPartner = (
    partnerId: string,
    data: ThgBankingDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgBankingViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/banking`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags banking
   * @name BankingControllerGetBankingForPartner
   * @summary Gets the Banking Information for a partner
   * @request GET:/partner/{partnerId}/banking
   * @secure
   * @response `200` `ThgBankingViewModelGen` The record has been successfully created
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  bankingControllerGetBankingForPartner = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<ThgBankingViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/banking`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
